module.exports = __webpack_public_path__ + "static/3-74d00113a8ca4d5a9c1f62b7d3129f6d.jpg";